import { Footer } from '@els/els-react--footer';
import { FOOTER_LEGAL_ENTITY, RoutePath } from 'constants/app.constant';
import { useEffect } from 'react';
var FOOTER_ID = 'app-footer';
var AppFooter = function () {
    useEffect(function () {
        var accessibilityLink = document.getElementById("".concat(FOOTER_ID, "-accessibility-link"));
        if (accessibilityLink) {
            accessibilityLink.removeAttribute('target');
            accessibilityLink.removeAttribute('rel');
        }
    }, []);
    return <Footer id={FOOTER_ID} legalEntity={FOOTER_LEGAL_ENTITY} accessibilityLink={"/#".concat(RoutePath.footerAccessibility)}/>;
};
export default AppFooter;
